import { FC } from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import intl from 'components/i18n/ReactIntlWrapper';
import { sortCollection } from '../../../common/utils';
import { SORT_TYPES } from '../../../common/constants';

type CountrySelectProps = {
  handleCountryChange: any;
  selectedCountry: any;
  countries: any;
  inputCountry: any;
  isClearable?: boolean;
  disabled?: boolean;
};

const CountrySelect: FC<CountrySelectProps> = ({
  handleCountryChange,
  selectedCountry,
  countries,
  inputCountry,
  isClearable = false,
  disabled = false,
}) => {
  const countriesSortedByName = sortCollection(countries, 'label', SORT_TYPES.ASC);

  return (
    <Autocomplete
      id="addressCountry"
      options={countriesSortedByName || []}
      getOptionLabel={(option) => intl.get(option.labelKey)}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      disabled={disabled}
      value={
        countries && selectedCountry != null && inputCountry !== ''
          ? countries.find((country) => country.labelKey === selectedCountry)
          : null
      }
      onChange={(event, newValue) => handleCountryChange(newValue)}
      loading={countries == null}
      clearOnEscape={isClearable}
      renderInput={(params) => (
        <TextField
          {...params}
          label={intl.get('addressForm.placeholder.country')}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {countries == null ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default CountrySelect;
